"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialsInput = void 0;
const react_1 = __importStar(require("react"));
const scaleFunction_1 = require("../../../../../../../helpers/scaleFunction");
const document_1 = require("../../../../../../../reducers/slices/document/document");
const react_redux_1 = require("react-redux");
const constants_1 = require("../../../../../../../constants/constants");
const useSearchDebounce_1 = require("../../../../../../../hooks/useSearchDebounce");
const update_single_element_thunk_1 = require("../../../../../../../reducers/slices/document/thunks/update/update_single_element_thunk");
const InitialsInput = ({ element, isEditable = true }) => {
    var _a, _b, _c;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument, documentErrors, documentState, selectedDocumentElements } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [value, setValue] = (0, useSearchDebounce_1.useSearchDebounce)();
    const stateCheck = documentState === constants_1.TYPE_LINK;
    (0, react_1.useEffect)(() => {
        if (value) {
            let _elem = Object.assign(Object.assign({}, element), { extra_attributes: Object.assign(Object.assign({}, element.extra_attributes), { value: value }) });
            dispatch((0, update_single_element_thunk_1.update_single_element_thunk)({
                data: {
                    document_id: selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument._id,
                    payload: _elem,
                },
            }));
        }
    }, [value]);
    return (react_1.default.createElement("input", { className: `bg-white border ${documentErrors.find((x) => x === element._id) ? "border-error" : "border-superDark"} focus:ring-superDark/20 focus:border-superDark ${stateCheck && isEditable ? "cursor-text" : stateCheck ? "cursor-not-allowed" : "cursor-move"} ${!isEditable ? "opacity-60" : ""}`, style: {
            width: "100%",
            height: "100%",
            padding: `${(0, scaleFunction_1.scaleFunction)(8)}px`,
            boxSizing: "border-box",
        }, onChange: (e) => {
            var _a, _b;
            // Block changes if not editable
            if (!isEditable)
                return;
            setValue((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value);
            dispatch((0, document_1.editSelectedDocumentElements)(Object.assign(Object.assign({}, element), { extra_attributes: Object.assign(Object.assign({}, element.extra_attributes), { value: (_b = e === null || e === void 0 ? void 0 : e.target) === null || _b === void 0 ? void 0 : _b.value }) })));
        }, value: stateCheck ? (_a = element.extra_attributes) === null || _a === void 0 ? void 0 : _a.value : "", placeholder: (_b = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _b === void 0 ? void 0 : _b.placeholder, required: (_c = element === null || element === void 0 ? void 0 : element.extra_attributes) === null || _c === void 0 ? void 0 : _c.required, readOnly: stateCheck && isEditable ? false : true, disabled: !isEditable }));
};
exports.InitialsInput = InitialsInput;
